import { GenericEntityBase, KeyType } from "../_models/GenericEntityBase";
import { NavigationProperty, NestedProperty, PropretyAttributes } from "../decorators/EntityDecorators";
import { Role } from "./matwins-tenant/Role.model";
import { i18nLanguage } from "./matwins-tenant/i18nLanguage.model";
import { IEntityMetaData, IPropretyAttribute } from "../_models/IEntityMetaData";

export class AccountBase extends GenericEntityBase<number> {

    @PropretyAttributes({
        attributes: [
            IPropretyAttribute.KeyProperty,
            IPropretyAttribute.Readonly
        ]
    })
    id: number = GenericEntityBase.GetDefaultId(KeyType.number);
    roleTitle?: string;

    @PropretyAttributes({ attributes: [] })
    isDisabled: boolean = false;

    @PropretyAttributes({ attributes: [] })
    permissions!: string;

    @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
    fK_Role!: number;

    @NavigationProperty({ TargetType: Role })
    role!: Role;


    GetType(): IEntityMetaData {
        return AccountBase.getMetaData();
    }
}